import React, { useState } from 'react';
import { X, Plus, Minus } from 'lucide-react';
import { sendEmail } from '../utils/emailService';
// import { uploadImages } from '../utils/imagehandler'
import { Toaster } from 'react-hot-toast';

const QuoteModal = ({ isOpen, onClose }) => {
  const [showAdditionalDropoff, setShowAdditionalDropoff] = useState(false);
  const [selectedImages, setSelectedImages] = useState([]);
  const [isUploading, setIsUploading] = useState(false);

  const handleImageChange = (e) => {
    setSelectedImages(Array.from(e.target.files));
  };

  React.useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsUploading(true);
    const formData = new FormData(e.target);
    
    const data = {
      form_type: 'quote',
      name: formData.get('name'),
      email: formData.get('email'),
      phone: formData.get('phone'),
      pickup: formData.get('pickupAddress'),
      pickupType: formData.get('pickupType'),
      startSQ: formData.get('startSQ'),
      dropoff: formData.get('dropAddress'),
      dropoffType: formData.get('dropType'),
      additional: formData.get('additionalAddress'),
      additionalType: formData.get('additionalType'),
      dropSQ: formData.get('dropSQ'),
      bedrooms: formData.get('bedrooms'),
      large_items: formData.get('largeItems'),
      boxes: formData.get('boxes'),
      stairs: formData.get('stairs'),
      elevator: formData.get('elevator'),
      parking: formData.get('parking'),
      specialty_items: formData.get('specialtyItems'),
      move_date: formData.get('moveDate'),
      additional_info: formData.get('additionalInfo')
    };
    
    const success = await sendEmail(data, "quote");
    if (success) {
      e.target.reset();
      setShowAdditionalDropoff(false);
      onClose();
    }
  };
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const toggleAdditionalDropoff = () => {
    setShowAdditionalDropoff(!showAdditionalDropoff);
  };

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
      onClick={handleBackdropClick}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div className="bg-white rounded-xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto relative">
        <Toaster position="top-center" />
        
        <button 
          onClick={onClose}
          className="absolute right-4 top-4 p-2 hover:bg-gray-100 rounded-full transition-colors duration-200"
          aria-label="Close modal"
        >
          <X className="w-6 h-6 text-gray-500 hover:text-gray-700" />
        </button>

        <div className="p-6 border-b border-gray-200">
          <h2 id="modal-title" className="text-2xl font-bold text-gray-800 pr-12">Get a Free Quote</h2>
        </div>
        
        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Name:
            </label>
            <textarea
              name="name"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
              rows="1"
              placeholder="First and Last Name"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Email:
            </label>
            <textarea
              name="email"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
              rows="1"
              placeholder="john.doe@example.com"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Phone Number:
            </label>
            <textarea
              name="phone"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
              rows="1"
              placeholder="555-555-5555"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              What's your starting location?
            </label>
            <textarea
              name="pickupAddress"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
              rows="1"
              placeholder="Street Address, City, and Zip"
              required
            />
            <select 
              name="pickupType"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
              required
            >
              <option value="House">House</option>
              <option value="Apartment">Apartment</option>
              <option value="Townhouse">Townhouse</option>
              <option value="Storage">Storage Unit</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              What is the starting location's square footage?
            </label>
            <input
              type="number"
              name="startSQ"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
              required
              min="0"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              What's your dropoff location?
            </label>
            <textarea
              name="dropAddress"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
              rows="1"
              placeholder="Street Address, City, and Zip"
              required
            />
            <select 
              name="dropType"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
              required
            >
              <option value="House">House</option>
              <option value="Apartment">Apartment</option>
              <option value="Townhouse">Townhouse</option>
              <option value="Storage">Storage Unit</option>
            </select>
            <button
              type="button"
              onClick={toggleAdditionalDropoff}
              className="mt-2 flex items-center gap-2 text-red-600 hover:text-red-700 transition-colors duration-200"
            >
              {showAdditionalDropoff ? (
                <>
                  <Minus className="w-4 h-4" />
                  Remove Additional Dropoff
                </>
              ) : (
                <>
                  <Plus className="w-4 h-4" />
                  Add Additional Dropoff
                </>
              )}
            </button>
          </div>

          {showAdditionalDropoff && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Additional Dropoff Location
              </label>
              <textarea
                name="additionalAddress"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                rows="1"
                placeholder="Street Address, City, and Zip"
                required
              />
              <select 
                name="additionalType"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
                required
              >
                <option value="House">House</option>
                <option value="Apartment">Apartment</option>
                <option value="Townhouse">Townhouse</option>
                <option value="Storage">Storage Unit</option>
              </select>
            </div>
          )}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              What is the dropoff location's square footage?
            </label>
            <input
              type="number"
              name="dropSQ"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
              required
              min="0"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              How many bedrooms will we need to move?
            </label>
            <input
              type="number"
              name="bedrooms"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
              required
              min="0"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Please list the larger items you'll need us to move (e.g., beds, sofas, dressers, applicances, etc.)
            </label>
            <textarea
              name="largeItems"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
              rows="3"
              placeholder="List any large items..."
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Approximately how many boxes?
            </label>
            <input
              type="number"
              name="boxes"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
              required
              min="0"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
            What floor are you on at the first and second location? 
            </label>
            <textarea
              name="stairs"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
              rows="2"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
            Is there an elevator? 
            </label>
            <select 
              name="elevator"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
              required
            >
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Is there accessible parking?
            </label>
            <select 
              name="parking"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
              required
            >
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Are there any specialty items that need to be moved? (Piano, Pool Table, etc.)
            </label>
            <textarea
              name="specialtyItems"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
              rows="3"
              placeholder="List any specialty items..."
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              What date are you looking to move on?
            </label>
            <input
              type="date"
              name="moveDate"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
              required
              min={new Date().toISOString().split('T')[0]}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Is there anything else you would like to tell us about your move?
            </label>
            <textarea
              name="additionalInfo"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500"
              rows="3"
              placeholder="Any additional information..."
            />
          </div>

          <button
            type="submit"
            className="w-full bg-red-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-red-700 transition-colors duration-300"
          >
            Submit Quote Request
          </button>
        </form>
      </div>
    </div>
  );
};
export default QuoteModal;